import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"filter\"><defs><style>#filter .cls-1{fill:none}</style></defs><title>资源 57</title><g id=\"filter_图层_2\" data-name=\"图层 2\"><g id=\"filter_图层_1-2\" data-name=\"图层 1\"><path id=\"filter_Rectangle_48_Copy\" data-name=\"Rectangle 48 Copy\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"filter_filter\"><path id=\"filter_Shape\" d=\"M13.75 21.76a.82.82 0 0 1-.61-.25l-2.94-3.05a.82.82 0 0 1-.23-.58v-6.14l-6.4-6.17A1.95 1.95 0 0 1 5 2.26h14.1A1.94 1.94 0 0 1 21 4.2a1.91 1.91 0 0 1-.57 1.37l-5.84 6.13v9.22a.85.85 0 0 1-.53.78.81.81 0 0 1-.31.06zM5 4a.26.26 0 0 0-.26.25.25.25 0 0 0 .08.18l6.64 6.42a.82.82 0 0 1 .25.59v6.15l1.19 1.31v-7.55a.86.86 0 0 1 .25-.6l6.07-6.37a.26.26 0 0 0 0-.36.31.31 0 0 0-.17-.02z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/filter.svg
// module id = PTMJ
// module chunks = 6